import styled from 'styled-components';

type CardCountProps = {
  centered: boolean;
};

export const CardCount = styled.span<CardCountProps>`
  display: block;
  text-align: ${props => (props.centered ? 'center' : 'right')};
  margin-top: ${props => (props.centered ? '-0.5rem' : '10%')};
  margin-bottom: 1rem;
  color: #757575;
`;

export const DesktopFilters = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const DesktopFilterHeader = styled.h5`
  font-weight: 400;
  font-size: 12px;
  font-family: Lato;
  color: #000;
  line-height: 12px;
  letter-spacing: 2px;
  text-transform: uppercase;
`;

export const DesktopClearFiltersButton = styled.h5`
  color: var(--01-primary-300757575, #757575);
  text-align: center;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 10px; /* 100% */
  letter-spacing: 1.5px;
  text-decoration-line: underline;
  text-transform: uppercase;
  cursor: pointer;
`;

export const H2Header = styled.h2`
  font-size: 14px;
  font-weight: 400;
  padding-top: 0;
  padding-bottom: 2rem;
  margin-block: 1em;
`;

export const SubcategoryNameHeading = styled.h2`
  font-family: Georgia;
  font-size: 24px;
  font-weight: 400;
  line-height: 32px;
  margin-top: 0;
`;